import { render, staticRenderFns } from "./CarisVehicleTable.vue?vue&type=template&id=66e385b0&scoped=true"
import script from "./CarisVehicleTable.vue?vue&type=script&lang=js"
export * from "./CarisVehicleTable.vue?vue&type=script&lang=js"
import style0 from "./CarisVehicleTable.vue?vue&type=style&index=0&id=66e385b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e385b0",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcaris-vehicle-table%2FCarisVehicleTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports